<template>
  <div>
    <div class="titlee">
      <h2 class="title">Comentarios</h2>
    </div>

    <TitleTable />

    <Data :data="data" :columns="columns" :getComentarios="getComentarios"/>
  </div>
</template>

<script>
import TitleTable from "./TitleTable";
import Data from "./Data.vue";
export default {
  components: {
    TitleTable,
    Data,
  },
  props: ["data", "columns", "getComentarios"]
};
</script>

<style scoped>
.row {
  margin: 0;
}

.titlee {
  margin: 30px 0;
}

.title {
  color: #052333;
  font-weight: 700;
  text-align: center;
  margin: 0 !important;
  font-size: 26px;
}
</style>
